module.exports = __webpack_public_path__ + "img/menuIcon29.7a88490c.png";